<div class="modal">
  <div class="modal-overlay" (click)="close()"></div>

  <div class="modal-dialog w-100" role="document">
    <div class="modal-content">
      <div class="modal-header d-flex justify-content-between">
        <h5 class="modal-title pt-0" i18n="@@DialogCookieNoticeHeader">Cookie notice and settings</h5>
        <a class="mr-2" (click)="close()">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </a>
      </div>

      <div class="modal-body pt-0">
        <h5 class="pt-0 pb-1" i18n="@@DialogCookieNoticeSubTitle">Necessary cookies</h5>
        <div i18n="@@DialogCookieNoticeMessage1">These cookies serve the technically correct operation of our website and cannot be deactivated in your systems.</div>
        <div i18n="@@DialogCookieNoticeMessage2">These cookies are not used to collect information about you for other purposes such as marketing or analysis.</div>

        <div class="modal-footer mt-4 p-0">
          <a class="m-0" (click)="agree()">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" i18n="@@DialogCookieNoticeAgreeButton">I agree</button>
          </a>
          <a class="m-0" (click)="close()">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" i18n="@@DialogCookieNoticeCancelButton">Cancel</button>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
